
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/ups-canada",
      function () {
        return require("private-next-pages/partners/ups-canada.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/ups-canada"])
      });
    }
  